<template>
  <div>
    <div class="header page-header">
      <div>INVOICE > {{invoice.invoice_number}}</div>
      <p>Invoice preview</p>
    </div>

    <div class="card invoice-totals">
      <span>
        <p class="sub-p">Due Date</p>
        <p class="info">{{moment(invoice.due_date).format('DD.MM.YYYY')}}</p>
      </span>
      <span>
        <p class="sub-p">Total Amount</p>
        <p class="info">{{invoice.total_amount}} {{ invoice.currency }}</p>
      </span>
      <span>
        <p class="sub-p">Status</p>
        <p>
          <Label :status="invoice.status" :error="invoice.callback_response && (JSON.parse(invoice.callback_response).ErrorMessage || (JSON.parse(invoice.callback_response).error_description))"/>
        </p>
      </span>
    </div>
    <div class="card card--spaced">
      <div class="top">
        <div class="left">
          <h5 class="sub-p" style="font-size: 18px;">{{invoice.customer && invoice.customer.name}}</h5>
          <p class="info">{{invoice.customer && invoice.customer.address}}</p>
          <p class="info" style="margin-bottom: 20px;">{{invoice.customer && invoice.customer.phone}}</p>
          <div class="inline-details">
            <div>
              <p class="sub-p" style="flex: 1">Buyer order number:</p>
              <p style="flex: 1.5" class="info">{{invoice.buyer_order_number}}</p>
            </div>
            <div style="display: flex">
              <p class="sub-p" style="flex: 1">Payment reference:</p>
              <p style="flex: 1.5" class="info">{{invoice.payment_reference}}</p>
            </div>
            <div style="display: flex">
              <p class="sub-p" style="flex: 1">Delivery address:</p>
              <p style="flex: 1.5" class="info">{{invoice.delivery_address}}</p>
            </div>
          </div>
        </div>
        <div class="right inline-details">
          <div class="space-between" style="margin-bottom: 10px;">
            <div
              style="color: #1880E1; margin-top: 0px; font-size: 18px; font-family: Montserrat-Medium;"
            >
              <span>Invoice</span>
            </div>
            <div
              style="color: #1880E1; float: right; text-align: right; font-family: Montserrat-Medium; font-size: 18px; margin-top: 0px;"
            >
              <span>{{invoice.invoice_number}}</span>
            </div>
          </div>
          <div class="space-between">
            <p class="sub-p" style>Merchant order number</p>
            <p class="info">{{invoice.merchant_order_number}}</p>
          </div>
          <div class="space-between">
            <p class="sub-p" style="flex: 1">Merchant contact name</p>
            <p class="info">{{invoice.merchant_contact_name}}</p>
          </div>
          <div class="space-between">
            <p class="sub-p" style="flex: 1">Issue date</p>
            <p class="info">{{moment(invoice.issue_date).format('DD.MM.YYYY')}}</p>
          </div>
          <div class="space-between">
            <p class="sub-p" style="flex: 1">Due date</p>
            <p class="info">{{moment(invoice.due_date).format('DD.MM.YYYY')}}</p>
          </div>
          <div class="space-between">
            <p class="sub-p" style="flex: 1">Order date</p>
            <p class="info">{{moment(invoice.order_date).format('DD.MM.YYYY')}}</p>
          </div>
          <div class="space-between">
            <p class="sub-p" style="flex: 1">Delivery date</p>
            <p class="info">{{moment(invoice.delivery_date).format('DD.MM.YYYY')}}</p>
          </div>
        </div>
      </div>
      <div class="bottom">
        <table class='header-table' style="width:100%">
          <col width="10%">
          <col width="30%">
          <col width="15%">
          <col width="15%">
          <col width="15%">
          <col width="15%">
          <tr>
            <th>Number</th>
            <th>Description</th>
            <th style="text-align: center">Quantity</th>
            <th style="text-align: center">Unit</th>
            <th style="text-align: center">Price</th>
            <th style="text-align: center">Amount</th>
          </tr>
          <tr
            v-for="article in invoice.invoice_articles"
            :key="article.id"
            class="table-row"
            @click="goToDetails(customer)"
          >
            <td>{{article.article_number}}</td>
            <td>{{article.article_description}}</td>
            <td style="text-align: center">{{article.quantity}}</td>
            <td style="text-align: center">{{article.unit}}</td>
            <td style="text-align: right">{{article.price_per_unit}}</td>
            <td style="text-align: right">{{article.total_vat_amount}} {{ invoice.currency }}</td>
          </tr>
        </table>
        <table class="simple" style="width:100%; margin-top: 64px">
          <col width="90%">
          <col width="10%">
          <tr>
            <td>Total exacl.Vat</td>
            <td style="text-align: right">{{invoice.details.total}} {{ invoice.currency }}</td>
          </tr>
          <tr>
            <td>VAT ({{invoice.details.vatAvg}}%)</td>
            <td style="text-align: right">{{invoice.details.vat}} {{ invoice.currency }}</td>
          </tr>
          <tr>
            <td>Total incl. VAT</td>
            <td style="text-align: right">{{invoice.total_vat_amount}} {{ invoice.currency }}</td>
          </tr>
        </table>
      </div>
      <p style="margin-top: 30px; padding-left: 10px;">
        <span class="sub-p">Comment: </span>
        <span style="font-weight: 300" class="info">{{invoice.comment}}</span>
      </p>
    </div>
    <p style="text-align: center" class='info'>
      Invoice URL : <a href="#">{{invoice.invoice_url}}</a>
    </p>
    <div class="card card--spaced card--history">
      <div class="top">
        <div class="left">
          <h5 class="sub-p" style="font-size: 18px;">Invoice History</h5>
        </div>
      </div>
      <div class="bottom">
        <center class="no-results" v-if="invoice.revision_history==0">There are no changes yet.</center>
        <table class="simple history" style="width:100%;" v-if="invoice.revision_history.length>0">
          <col width="6%">
          <col width="24%">
          <col width="20%">
          <col width="22%">
          <col width="6%">
          <col width="22%">
          <tr v-for="item in invoice.revision_history">
            <td style="text-align: right;color:#989898;">↱</td>
            <td><p class="info">{{item.updated_at}}</p></td>
            <td class="bold">{{item.key}}</td>
            <td style="text-align: center;background:#f1f1f16e">{{item.old_value}}</td>
            <td style="text-align: center;font-size: 16px;color: #989898;">⇢</td>
            <td style="text-align: center;background: #ecffe5;">{{item.new_value}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "./api.js";
import Label from "../partials/Label";
import moment from "moment";

export default {
  name: "InvoiceDetails",
  created: async function() {
    this.invoice = await api.fetchInvoice(this.$route.params.id);
    document.title =
      "Invoice No. " + this.invoice.invoice_number + " | PayGate Invoice";
  },
  components: {
    Label
  },
  data() {
    return {
      moment: moment,
      invoice: {
        name: "",
        status:"",
        details: {
          total: "",
          vat: ""
        },
        customer: {
          name: "",
          phone: "",
          address: ""
        },
        invoice_articles: [],
        revision_history: [],
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.header-table {
    border-radius: 0px !important;
  tr {
    border: 1.5px solid #DFE2E6;
  }
  th {
    color: #4A4A4A !important;
    font-family: Montserrat-SemiBold;
  }
}
.invoice-totals {
  display: flex;
  align-items: center;
  justify-content: space-around;

  & > span {
    text-align: center;
  }
}

.top {
  flex: 1;
  display: flex;
  margin-bottom: 32px;
}
.space-between {
  display: flex;
  justify-content: space-between;
}
.left {
  flex: 1.5;

  .sub-p,
  p {
    margin-top: 0;
    margin-bottom: 6px;
  }
}

.right {
  flex: 1;

  .sub-p,
  p {
    margin-top: 0;
    margin-bottom: 6px;
  }
}

.bottom {
  flex: 1.3;
}
.sub-p {
  font-family: Montserrat-Medium;
}
.inline-details > div {
  display: flex;
}
.info {
  font-family: Montserrat-Regular;
}
.card--history {
  margin-bottom: 48px;
}
.card--history .top {
  margin-bottom: 0;
}
.card--history .no-results {
  border: 1px solid #eaeaea9e;
  padding: 42px;
  background: #f9f9f98f;
  color: #8a8a8a;
  font-weight: normal;
}
table.simple.history td {
  padding: 0px 6px;
}
.bold {
  font-weight: bold;
}
</style>
